import { EmailListType } from 'modules/profile/mailing-settings/types/email-list-interface'
import { useEffect, useState } from 'react'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useEmailList = (isReady?: boolean) => {
  const { user } = useUser()
  const [shouldFetch, setShouldFetch] = useState(false)

  useEffect(() => {
    if (isReady) {
      setShouldFetch(true)
    }
  }, [isReady])

  const { fetcher } = useFetch<RequestMethodsEnum.get, EmailListType>({
    method: RequestMethodsEnum.get,
  })
  return useSWR(
    () => user && shouldFetch && '/api/dashboard/customer/mailing/sender-email/full-list',
    fetcher,
  )
}
